// Ported from packages/workflow-engine-upstream/ui/src/progress-text.ts at commit bebc382; unchanged.
// Words and clocks for the progress card (Progress.tsx), kept apart so tests can check them.

/** "0:07", "4:16". */
export function clock(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** Calls stall after 120 s (src/model/openai.ts): the engine then asks once more, and a second stall fails the call. */
export const STALL_MS = 120_000;
const SLOW_MS = 30_000;

/** What the run waits on while a model call is out, by how long it has been out. */
export function waitLine(ms: number): { text: string; slow: boolean } {
  const s = Math.floor(ms / 1000);
  if (ms < SLOW_MS) return { text: `Waiting for the model · ${s} s`, slow: false };
  if (ms < STALL_MS) return { text: `The model is slow to reply · ${s} s`, slow: true };
  return { text: `No reply after ${Math.floor(STALL_MS / 1000)} s. The engine asks the model again once; a second stall stops this call. · ${s} s`, slow: true };
}

/** What the engineer must do while the run waits on them. */
export const YOURS: Record<string, string> = {
  ask: 'Answer the question in the Conversation column. The run is paused, and this time is not counted.',
  approval: 'Read the plan, then approve or edit it in the Plan column. The run is paused, and this time is not counted.',
};
